<script setup lang="ts">
import { ICONS, type IconName } from '~/utils/icons'

/** Source sizes use the 14px reference scale; rem units follow the site's font setting. */
withDefaults(defineProps<{ name: IconName; size?: number }>(), { size: 11 })
</script>

<template>
  <!-- The local registry contains static SVG paths, never user-supplied markup. -->
  <!-- eslint-disable vue/no-v-html -->
  <svg
    :width="`${size / 14}rem`" :height="`${size / 14}rem`" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="shrink-0"
    v-html="ICONS[name]"
  />
  <!-- eslint-enable vue/no-v-html -->
</template>
